<navigation (languageChanged)="ngOnChanges()"></navigation>
<div class="container">
  <div class="row">
    <div class="col-lg-3">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-12">
          <news-headers [newsItems]="newsItems | extractNewsItemsSafely"></news-headers>
        </div>
        <div class="col-12 col-md-6 col-lg-12">
          <activity-container [messages]="customerActivities"></activity-container>
        </div>
        <div class="col-12 col-md-6 col-lg-12">
          <notification-container [messages]="customerNotifications"></notification-container>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="row">
        <div class="col-lg-8 col--flex">
          <combined-service-tile [subscriptions]="topSubscriptions"></combined-service-tile>
        </div>
        <div class="col-lg-4">
          @for (subscription of sideSubscriptions | keyvalue: asIsOrder; track subscription.key) {
            <div>
              <dashboard-tile
                [subscription]="subscription"
                [customerActivities]="customerActivities"
                [wirelessEnabled]="wirelessEnabled"
              />
            </div>
          }
        </div>
      </div>

      <div class="row">
        @for (subscription of bottomSubscriptions | keyvalue: asIsOrder; track subscription.key) {
          <div class="col-md-6 col-lg-4 col--flex">
            <dashboard-tile
              [subscription]="subscription"
              [customerActivities]="customerActivities"
              [wirelessEnabled]="wirelessEnabled"
            />
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="container">
  <footer></footer>
</div>
